<ngx-spinner type="ball-clip-rotate"></ngx-spinner>
<header class="header">
  <div class="arrow-button" onclick="history.back()"></div>
  <p class="text-h5">認証メールの再送信</p>
</header>

<div class="container">
  <p class="text-body-1">
    下記に登録したメールアドレスを入力してください。再度、認証メールをお送りします。
  </p>

  <form
    id="change-password-form"
    class="v-application--is-ltr"
    (submit)="submit()"
  >
    <div
      class="v-input v-input--is-label-active v-input--is-dirty v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
    >
      <div class="v-input__control mb-6">
        <app-aihobs-ecs-input
          [(ngModel)]="email"
          name="email"
          placeholder="メールアドレス"
          class="text-black-38"
        ></app-aihobs-ecs-input>
        <!-- <div class="v-input__slot">
        <div class="v-text-field__slot">
          <label
            for="input-13"
            [ngClass]="inputLabelClass"
            class="text-black-38"
            style="left: 0px; right: auto; position: absolute"
            >メールアドレス</label
          ><input
            (focus)="state.isFocus = true"
            (blur)="state.isFocus = false"
            id="input-13"
            name="input-13"
            type="email"
            [(ngModel)]="email"
          />
        </div>
      </div> -->
      </div>
    </div>

    <div _ngcontent-ohw-c49="" class="text-center mb-5">
      <button
        _ngcontent-ohw-c49=""
        type="submit"
        medium=""
        class="full-width primary-button v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary"
      >
        <span _ngcontent-ohw-c49="" class="text-button-medium v-btn__content">
          送信する
        </span>
      </button>
    </div>
  </form>
</div>
